<template>
  <v-data-table :headers="headers" :items="items" hide-actions class="c-insurance-plan simple-table">
    <template slot="headers" slot-scope>
      <tr>
          <td style="font-size:14px">方案选择</td>
          <td>
            <v-layout justify-center align-center>
              <v-combobox
                class="v-select"
                item-text="name"
                :items="selectPlanList"
                v-model="oc3Plan"
                item-value="value"
                solo
                hide-details
                background-color="#dd122a"
                @change="planChange($event, 'oc3')"
                dark
              ></v-combobox>
            </v-layout>
          </td>
        <td>
          <v-layout justify-center align-center>
            <v-combobox
              class="v-select"
              item-text="name"
              v-model="oc4Plan"
              :items="selectPlanList"
              item-value="value"
              solo
              hide-details
              @change="planChange($event, 'oc4')"
              background-color="#dd122a"
              dark
            ></v-combobox>
          </v-layout>
        </td>
        <td>
          <v-layout justify-center align-center>
            <v-combobox
              class="v-select"
              item-text="name"
              v-model="oc5Plan"
              @change="planChange($event, 'oc5')"
              :items="selectPlanList.filter(item=>item.name!=='计划九'&&item.name!=='计划十')"
              item-value="value"
              solo
              hide-details
              background-color="#dd122a"
              dark
            ></v-combobox>
          </v-layout>
        </td>
      </tr>
      <tr>
        <th class="text-xs-left">投保员工人数</th>
        <th class="thead-th">
          1-3类职业
          <strong v-if="employees.length > 0">{{ oc3Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc3Count" class="thead-input"></v-text-field>人
        </th>
        <th class="thead-th">
          4类职业
          <strong v-if="employees.length > 0">{{ oc4Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc4Count" class="thead-input"></v-text-field>人
        </th>
        <th class="thead-th">
          5-6类职业
          <strong v-if="employees.length > 0">{{ oc5Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc5Count" class="thead-input"></v-text-field>人
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr>
        <td>{{ props.item.name }}</td>
        <td>
          <v-layout justify-center align-center>
            <p class="thead-input">{{props.item.selected.oc3}}</p>
          </v-layout>
        </td>
        <td>
          <v-layout justify-center align-center>
            <p class="thead-input">{{props.item.selected.oc4}}</p>
          </v-layout>
        </td>
        <td>
          <v-layout justify-center align-center>
          <p class="thead-input">{{props.item.selected.oc5}}</p>
          </v-layout>

        </td>
      </tr>
    </template>
    <template slot="footer">
      <td>
        <strong>保费</strong>
      </td>
      <td class="text-xs-center">
        <strong class="primary-text">￥ {{ oc3Price }}</strong>
        <span v-show="oc3Count > 0" class="caption">(每人￥ {{ (oc3Price/oc3Count).toFixed(2) }})</span>
      </td>
      <td class="text-xs-center">
        <strong class="primary-text">￥ {{ prices.oc4 }}</strong>
        <span v-show="oc4Count > 0" class="caption">(每人￥ {{ (prices.oc4/oc4Count).toFixed(2) }})</span>
      </td>
      <td class="text-xs-center">
        <!-- <strong class="primary-text">￥ {{ prices.oc5 }}</strong>oc5Price -->
        <strong class="primary-text">￥ {{ oc5Price }}</strong>
        <span v-show="oc5Count > 0" class="caption">(每人￥ {{ (oc5Price/oc5Count).toFixed(2) }})</span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import selectPlanList from '@/assets/js/planList'
export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    // planId: Number,
    employees: {
      type: Array,
      default() {
        return [];
      }
    },
    effectDuration: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      oc3PlanList:[],
      oc4PlanList:[],
      oc5PlanList:[],
      oc3Plan:"",
      oc4Plan:"",
      oc5Plan:"",
      // 产品方案只有一个方案D了。原来是选择的，从 props 接受，现在只有一个了直接定义在这里
      selectPlanList:selectPlanList,
      headers: [
        {
          text: "投保员工人数",
          value: "name",
          sortable: false
        },
        {
          text: "1-3类职业0人",
          value: "insuranceAmountList",
          sortable: false,
          width: "200"
        },
        {
          text: "4类职业0人",
          sortable: false,
          width: "200"
        },
        {
          text: "5类职业0人",
          sortable: false,
          width: "200"
        }
      ],
      items: [
        {
          name: "意外身故及伤残保障",
          insuranceAmountList: [
            { text: "5万", value: 50000 },
            { text: "10万", value: 100000 },
            { text: "20万", value: 200000 },
            { text: "30万", value: 300000 },
            { text: "40万", value: 400000 },
            { text: "50万", value: 500000 },
            { text: "60万", value: 600000 },
            { text: "70万", value: 700000 },
            { text: "80万", value: 800000 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 3,
              maxInsuranceAmount: 800000
            },
            {
              minOccupationalCategory: 4,
              maxOccupationalCategory: 4,
              maxInsuranceAmount: 600000
            },
            {
              minOccupationalCategory: 5,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: 500000
            }
          ],
          selected: {
            oc3: 0,
            oc4: 0,
            oc5: 0
          }
        },
        {
          name: "意外医药补偿",
          insuranceAmountList: [
            { text: "不投保", value: 0 },
            { text: "5000元", value: 5000 },
            { text: "1万", value: 10000 },
            { text: "2万", value: 20000 },
            { text: "3万", value: 30000 },
            { text: "4万", value: 40000 },
            { text: "5万", value: 50000 },
            { text: "6万", value: 60000 },
            { text: "7万", value: 70000 },
            { text: "8万", value: 80000 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 3,
              maxInsuranceAmount: [80000, "${primary} * 0.2"]
            },
            {
              minOccupationalCategory: 4,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: [60000, "${primary} * 0.1"]
            }
          ],
          selected: {
            oc3: 0,
            oc4: 0,
            oc5: 0
          }
        },
        {
          name: "意外每日住院津贴",
          insuranceAmountList: [
            { text: "不投保", value: 0 },
            { text: "30元/天", value: 30 },
            { text: "50元/天", value: 50 },
            { text: "100元/天", value: 100 },
            { text: "150元/天", value: 150 },
            { text: "200元/天", value: 200 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: [200, "${primary} * 0.001"]
            }
          ],
          selected: {
            oc3: 0,
            oc4: 0,
            oc5: 0
          }
        },
      ],
      // select items 数据
      selectesItems: [
        {
          oc3: [],
          oc4: [],
          oc5: []
        },
        {
          oc3: [],
          oc4: [],
          oc5: []
        },
        {
          oc3: [],
          oc4: [],
          oc5: []
        }
      ],
      prices: {
        oc1: 0,
        oc2: 0,
        oc3: 0,
        oc4: 0,
        oc5: 0,
        oc6: 0
      },
      // 记录用户手动输入的 职业类别 人数
      categoryCounter: {
        oc3Count: 0,
        oc4Count: 0,
        oc5Count: 0
      }
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
    oc3Price() {
      if(this.oc3Count == 0){
        return 0;
      }else{
        const price = this.prices.oc1 + this.prices.oc2 + this.prices.oc3;
        return Math.round(price * 100) / 100;
      }
    },
    oc5Price(){
      if(this.oc5Count == 0){
        return 0
      }else{
        const price = this.prices.oc5 + this.prices.oc6;
        return Math.round(price * 100) / 100;
      }
    },
    oc3Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc3Count;
      }
      return this.employees.filter(item => item.category.level <= 3).length;
    },
    oc4Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc4Count;
      }
      return this.employees.filter(item => item.category.level === 4).length;
    },
    oc5Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc5Count;
      }
      return this.employees.filter(item => item.category.level >= 5).length;
    },
    totalPrice() {
      const totalPrice = this.oc3Price + this.prices.oc4 + this.oc5Price;
      return Math.round(totalPrice * 100) / 100;
    },
    disabledZyylx() {
      if (this.effectDuration < 4) {
        return true;
      }
      return false;
    }
  },
  watch: {
    totalPrice(totalPrice) {
      this.$emit("input", totalPrice);
    },
    // 保障期限变了，重新计算保费
    effectDuration() {
      this.getPrice(0);
    },
    // 保障方案变了，重新计算保费
    // planId() {
    //   this.getPrice(0);
    // },
    oc3Count() {
      this.getPrice(3);
    },
    oc4Count(val) {
      if(val == 0){
        this.prices.oc4 = 0
      }
      this.getPrice(4);
    },
    oc5Count() {
      this.getPrice(5);
    },
    // 人数变了，重新计算保费
    employees() {
      this.getPrice(0);
    }
  },
  created() {
    // 初始化 select items 数据
    this.selectesItems.forEach((element, index) => {
      element.oc3 = this.getSelectItems(index, 3);
      element.oc4 = this.getSelectItems(index, 4);
      element.oc5 = this.getSelectItems(index, 5);
    });
  },
  mounted() {
    this.getPrice(0);
  },
  methods: {
    planChange(val,type){
      this.items[0].selected[type] = val.value.accMoney;
      this.items[1].selected[type] = val.value.accDrug;
      this.items[2].selected[type] = val.value.accHospital;
      this.getPrice(parseInt(type.slice(2,3)))
    },
    calculate(expression) {
      return eval(expression);
    },
    /**
     * index: items 索引
     * occupationalCategory：职业类别
     */
    getSelectItems(index, occupationalCategory) {
      const item = this.items[index];
      const limit = item.limits.find(
        element =>
          element.minOccupationalCategory <= occupationalCategory &&
          element.maxOccupationalCategory >= occupationalCategory
      );
      // 没有匹配返回全部
      if (!limit) {
        return item.insuranceAmountList;
      }
      let maxInsuranceAmount = limit.maxInsuranceAmount;
      if (maxInsuranceAmount instanceof Array) {
        // 取数组最大值：排序后取最后一个
        let tempValue =
          item.insuranceAmountList[item.insuranceAmountList.length - 1].value;
        maxInsuranceAmount.forEach(element => {
          if (typeof element === "number") {
            tempValue = Math.min(element, tempValue);
          } else {
            const primary = this.items[0].selected["oc" + occupationalCategory];
            const expression = element.replace(/\$\{primary\}/g, primary); // primary = 主险保额
            const calculateValue = this.calculate(expression);
            tempValue = Math.min(calculateValue, tempValue);
          }
        });
        maxInsuranceAmount = tempValue;
      }
      const validList = item.insuranceAmountList.filter(
        element => element.value <= maxInsuranceAmount
      );
      return validList;
    },
    vselectOnChange(index, occupationalCategory) {
      if (index === 0) {
        for (let num = 1; num <= 2; num++) {
          this.selectesItems[num][
            "oc" + occupationalCategory
          ] = this.getSelectItems(num, occupationalCategory);
        }
      }
      setTimeout(() => {
        this.getPrice(occupationalCategory);
      }, 200);
    },
    getPrice(occupationalCategory) {
      if(this.oc3Plan ===""&&this.oc4Plan===""&&this.oc5Plan === ""){
        return false
      }
      // 没有保障期限无法计算保费
      if (!this.effectDuration) {
        return false;
      }
      // 需要计算的职业类别
      const categories =
        occupationalCategory === 0
          ? [1, 2, 3, 4, 5]
          : occupationalCategory === 3
          ? [1, 2, 3]
          : occupationalCategory === 5
          ? [5,6]
          : [occupationalCategory];

      let planList = [];
      categories.forEach(category => {
        const applicantCount = this.getCounterOfCategory(category);
        let planProductList = [];
        if (applicantCount > 0) {
          planProductList = this.items.map((item, index) => {
            const productId = this.product.children[index].id;
            // 住院医疗保险如果禁用了，保额传 0
            if (index === 3 && this.disabledZyylx) {
              return { productId, coverage: 0 };
            }
            const coverage =
              category === 5
                ? item.selected.oc5
                : category === 4
                ? item.selected.oc4
                : item.selected.oc3;
            return { productTermsId: productId, coverage };
          });
          planList.push({
            jobLevel: category,
            planId: this[`oc${category == 1||category == 2?3:category == 6?5:category}Plan`].value.id,
            planName: this[`oc${category == 1||category == 2?3:category == 6?5:category}Plan`].value.name,
            applicantCount: applicantCount,
            planProductTermsList: planProductList
          });
        }
      });
      console.log(planList)
      if(occupationalCategory == 3){
        this.oc3PlanList = planList
      }else if(occupationalCategory == 4){
        this.oc4PlanList = planList
      }else if(occupationalCategory == 5){
        this.oc5PlanList = planList
      }
      let newPlan = [...this.oc3PlanList,...this.oc4PlanList,...this.oc5PlanList]
      this.$emit("update:planList", newPlan);
      // 没有 plan ，无需请求接口
      if (planList.length === 0) {
        return false;
      }

      const entity = {
        productId: parseInt(this.code),
        insurancePeriod:  this.effectDuration >= 12?1:this.effectDuration,
        insurancePeriodUnit: this.effectDuration >= 12?3:2,
        planList: planList
      };
      // 发起请求
      this.$axios
        .post("/app/api/heshunbao/trialPrice", entity)
        .then(res => {
          res.data.forEach(item => {
            this.prices["oc" + item.level] = item.basePrice;
          });
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    getCounterOfCategory(category) {
      if (this.employees.length === 0) {
        let count = 0;
        if (category === 5) {
          count = this.categoryCounter.oc5Count;
        } else if (category === 4) {
          count = this.categoryCounter.oc4Count;
        } else if (category === 3) {
          count = this.categoryCounter.oc3Count;
        } else {
          count = 0;
        }
        if (isNaN(count)) {
          return 0;
        }
        return parseInt(count);
      }
      return this.employees.filter(item => item.category.level === category)
        .length;
    }
  }
};
</script>

<style lang="scss">
.c-insurance-plan {
  width: 745px !important;
  .thead-th {
    width: 195px;
    .thead-input {
      width: 3em;
      display: inline-block;
    }
  }
  // 框架样式覆盖
  .v-text-field.v-text-field--solo .v-input__control {
    flex: none;
    width: 120px;
    min-height: 30px;
  }
  .v-select {
    justify-content: center;
    font-size: inherit;
  }
}
</style>


